import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  fetchTranslationsFor,
  translatePage,
} from "/WebInterface/new-ui/modules/localizations/localizations.js";

window.translations = {};
window.locale = "";

const setLocale = async ({ newLocale }) => {
  if (newLocale === locale) return;

  const newTranslations = await fetchTranslationsFor(newLocale);
  document.documentElement.lang = newLocale;

  locale = newLocale;
  translations = newTranslations;
  translatePage();
};

export default setLocale;
